import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

export default function EmailSuccessModal({
  open,
  onClose,
  onSendAnother,
  count,
  isCombine,
  combineName,
}) {
  const displayCombineName = combineName?.trim() || "this combine";

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-xl rounded-lg bg-white shadow-xl p-10 text-center">
          <div className="text-4xl mb-4">✅</div>
          <div className="text-2xl font-semibold mb-2">
            Email Sent Successfully
          </div>

          <div className="text-gray-700 mb-8">
            {isCombine ? (
              <>
                Your email has been sent to <b>{count}</b> members of{" "}
                <b>{displayCombineName}</b>.
              </>
            ) : (
              <>
                Your email has been sent to <b>{count}</b> users.
              </>
            )}
          </div>

          <div className="flex justify-center gap-4">
            <button
              className="px-8 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
              onClick={onClose}
              type="button"
            >
              Close
            </button>

            <button
              className="px-8 py-2 rounded bg-red-500 text-white hover:bg-red-700"
              onClick={onSendAnother}
              type="button"
            >
              Send Another Email
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
